export const shouldLoadCompanyArtFolderSelector = () => false;
export const shouldSaveCompanyArtFolderSelector = () => false;